<template>
    <div class="row">
        <div class="col">
            <div class="form-group">
                <select v-model="selectedCounty" class="form-control">
                    <option v-for="county in counties" 
                            :key="county.countyId"
                            :value="county"
                            class="form-control-item">{{ county.name }}</option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
    props: [ 'value' ],
    computed: { 
        ...mapState({
            counties: state => state.static.counties
        }),
        ...mapGetters([ 'days', 'nights' ]),
        selectedCounty: {
            get() { 
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    }
}
</script>